import Service from "../../Services";

const Location = {
  namespaced : true,
  state : {
    form : {
      branch_id : '',
      tcdc_mini_id : '',
      description_en : '',
      description_th : '',
      address_th : '',
      address_en : '',
      postal_address_th : '',
      postal_address_en : '',
      opening_hours_detail_th : '',
      opening_hours_detail_en : '',
      lat : '',
      lon : '',
      attached_website : '',
      service_area_title_th : '',
      service_area_title_en : '',
      opening_hours : [],
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        branch_id : '',
        tcdc_mini_id : '',
        description_en : '',
        description_th : '',
        service_area_title_th : '',
        service_area_title_en : '',
        address : '',
        postal_address : '',
        opening_hours_detail : '',
        lat : '',
        lon : '',
        attached_website : '',
        opening_hours : [],
      }
    }
  },
  actions : {
    getLocation({commit},{page,search,sort_branch,sort_date}){
      return Service.LocationAPI.getLocation(page,search,sort_branch,sort_date);
    },
    showLocation({commit},id){
      return Service.LocationAPI.showLocation(id);
    },
    saveLocation({commit},{id,data}){
      if(id){
        return Service.LocationAPI.updateLocation(id,data);
      }else{
        return Service.LocationAPI.createLocation(data);
      }
    },
    deleteLocation({commit},id){
      return Service.LocationAPI.deleteLocation(id);
    },
    setFormLocation({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default Location
